export function AffinityGamesGlobe({ size = 44 }: { size?: number }) {
  return <svg className="affinity-games-globe" viewBox="0 0 48 48" width={size} height={size} aria-hidden="true">
    <defs><radialGradient id="affinity-globe-ocean" cx="31%" cy="25%"><stop stopColor="#bff4ff" /><stop offset=".34" stopColor="#4bbce7" /><stop offset="1" stopColor="#17618e" /></radialGradient></defs>
    <circle className="affinity-games-globe__ocean" cx="24" cy="24" r="17" />
    <path className="affinity-games-globe__land" d="M12 15c3-4 8-6 12-6l-2 5 3 3-2 4-4-1-2 4-5-1v-5Zm12 12 4-3 4 2 5-1c-1 7-6 12-13 15l-1-5 3-3-2-5Zm-9-1 5 1 2 4-2 5c-5-2-8-7-8-12l3 2Zm17-12 4 4-1 4-5-1-2-4 4-3Z" />
    <path className="affinity-games-globe__shine" d="M15 14c3-3 7-5 11-5" />
  </svg>;
}
